import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';

const style = ({ avatar }) => ({ root: avatar.large });
Avatar.Large = withStyles(style)(Avatar);

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar.js